import { render, staticRenderFns } from "./TransferIntoAbroad.vue?vue&type=template&id=be2e0a0a&scoped=true&"
import script from "./TransferIntoAbroad.vue?vue&type=script&lang=ts&"
export * from "./TransferIntoAbroad.vue?vue&type=script&lang=ts&"
import style0 from "./TransferIntoAbroad.vue?vue&type=style&index=0&id=be2e0a0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e0a0a",
  null
  
)

export default component.exports